<template>
  <div class="full-page" @keyup.enter="submitLogin">
    <notifications></notifications>
    <div class="wrapper wrapper-full-page">
      <div class="page-header header-filter" :class="setPageClass" filter-color="black" :style="setBgImage">
        <div class="container md-offset">
          <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
            <div class="md-layout text-center">
              <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
                <login-card header-color="green">
                  <md-field class="md-form-group" style="margin-top:15;" slot="inputs" :class="[
                      {'md-invalid': errors.has('会社コード')},
                      {'md-error': errors.has('会社コード')}]">
                    <md-icon>business</md-icon>
                    <label>会社コード</label>
                    <md-input v-model="company" style="ime-mode:disabled" name="company" data-vv-name="会社コード" v-validate="'required'"></md-input>
                    <span class="md-error">{{ errors.first('会社コード') }}</span>
                  </md-field>
                  <md-field class="md-form-group" slot="inputs" :class="[
                      {'md-invalid': errors.has('ログインID')},
                      {'md-error': errors.has('ログインID')}]">
                    <md-icon>face</md-icon>
                    <label>ログインID</label>
                    <md-input v-model="login" style="ime-mode:disabled" type="login" name="login" data-vv-name="ログインID" v-validate="'required'"></md-input>
                    <span class="md-error">{{ errors.first('ログインID') }}</span>
                  </md-field>
                  <md-field class="md-form-group" slot="inputs" :class="[
                      {'md-invalid': errors.has('パスワード')},
                      {'md-error': errors.has('パスワード')}]">
                    <md-icon>lock_outline</md-icon>
                    <label>パスワード</label>
                    <md-input v-model="password" style="ime-mode:disabled" name="password" data-vv-name="パスワード" type="password" v-validate="'required'"></md-input>
                    <span class="md-error">{{ errors.first('パスワード') }}</span>
                  </md-field>
                    <md-button slot="footer" class="md-button md-success md-theme-default" @click="submitLogin" style="height: 36px"> 
                      ログイン
                    </md-button>
                    <div class="pull-right small" slot="inputs"> 
                     パスワードを忘れた方は<a href="login_remind">こちら</a>
                    </div>
                </login-card>
              </div>
            </div>
          </zoom-center-transition>
        </div>
        <footer class="footer">
          <div class="container md-offset">
              <div class="copyright text-center">
                &copy; {{ new Date().getFullYear() }} <a href="https://www.samurai-net.co.jp" target="_blank">Samurai, inc</a>&nbsp;All Rights Reserved.
              </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
  import {ZoomCenterTransition} from 'vue2-transitions'
  import LoginCard from '../components/Cards/LoginCard.vue'
  import { csrfToken } from 'rails-ujs'
  import router from '../packs/router.js'
  import store from '../packs/store.js'

  export default {
    components: {
      ZoomCenterTransition,
      LoginCard
    },
    props: {
      backgroundColor: {
        type: String,
        default: 'black'
      }
    },
    inject: {
      autoClose: {
        default: true
      }
    },
    data() {
      return {
        responsive: false,
        showMenu: false,
        menuTransitionDuration: 250,
        pageTransitionDuration: 300,
        year: new Date().getFullYear(),
        company: this.$Cookies.get('company'),
        login: this.$Cookies.get('login'),
        password: null
      }
    },
    computed: {
      setBgImage(){
        let image = '/images/login/login-' + (Math.floor(Math.random() * 5) + 1) + '.jpg'
        return {
          backgroundImage: `url(${image})`
        }
      },
      setPageClass(){
        return `login-page`.toLowerCase();
      },
      authenticityToken(){
        return csrfToken()
      }
    },
    methods: {
      onResponsiveInverted () {
        if (window.innerWidth < 991){
          this.responsive = true
        } else {
          this.responsive = false
        }
      },
      submitLogin(){
        this.$validator.validateAll().then(result =>  {
          if (result) {
            this.sendLogin()
          }
        })
      },
      sendLogin(){
        this.axios.post(this.AdminApiUrl + '/sessions',  {
            company: this.company,
            login: this.login,
            password: this.password
        })
        .then(response => {
          this.$Cookies.set('loginId', response.data.login, { expires: 1 })
          if (response.data.role === 'shop') {
            this.$Cookies.set('belongs', response.data.shop.name, { expires: 1 })
            this.$Cookies.set('shopId', response.data.shop.id, { expires: 1 })
          } else {
            this.$Cookies.set('belongs', response.data.company.name, { expires: 1 })
          }
          this.$Cookies.set('companyId', response.data.company.id, { expires: 1 })
          this.$Cookies.set('companyCode', this.company, { expires: 1 })
          this.$Cookies.set('role', response.data.role, { expires: 1 })
          this.$Cookies.set('accessToken', response.data.access_token, { expires: 1 })
          this.$Cookies.set('accessTokenExpireDate', response.data.access_token_expire_date, { expires: 1 })
          this.$Cookies.set('flag_order_change', response.data.is_order_change, { expires: 1 })
          this.$Cookies.set('flag_preOrder', response.data.company.is_pre_order_enable, { expires: 1 })
          this.$Cookies.set('flag_qrPayment', response.data.company.is_qr_payment_enable, { expires: 1 })
          this.$Cookies.set('flag_reserveOrder', response.data.company.is_reserve_order_enable, { expires: 1 })
          this.$Cookies.set('flag_houseMoney', response.data.company.is_house_money_enable, { expires: 1 })
          this.$Cookies.set('flag_stamp', response.data.company.is_stamp_enable, { expires: 1 })
          this.$Cookies.set('flag_point', response.data.company.is_point_enable, { expires: 1 })
          this.$Cookies.set('flag_pushNotice', response.data.company.is_push_notification_enable, { expires: 1 })
          this.$Cookies.set('flag_coupon', response.data.company.is_coupon_enable, { expires: 1 })
          this.$Cookies.set('flag_mailMagazine', response.data.company.is_mail_magazine_enable, { expires: 1 })
          this.$Cookies.set('flag_ecOrder', response.data.company.is_ec_order_enable, { expires: 1 })
          this.$Cookies.set('flag_api', response.data.company.is_api_enable, { expires: 1 })
          this.$Cookies.set('flag_lineMiniAppSalesReport', response.data.is_line_mini_app_sales_report_enable, { expires: 1 })
          this.setShop()
          router.push({ path: '/admin/top' })
        })
        .catch(error => {
          this.dangerNotify('ログインIDかパスワードが違います')
        })
      },
      setShop () {
        this.axios({
          method  : 'GET',
          url     : this.AdminApiUrl + '/shops/select_list',
          timeout : 10000,
          headers : {'Authorization': this.$Cookies.get('accessToken')}
        }).then(response => {
          sessionStorage.setItem('shopSelect', JSON.stringify(response.data))
        })
      }
    },
    mounted() {
      this.onResponsiveInverted();
      window.addEventListener('resize', this.onResponsiveInverted)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onResponsiveInverted)
    },
    beforeRouteUpdate(to, from, next) {
      // Close the mobile menu first then transition to next page
      if (this.showMenu) {
        setTimeout(() => {
          next()
        }, this.menuTransitionDuration)
      } else {
        next()
      }
    }
  }
</script>
<style lang="scss" scoped>
  $scaleSize: .1;
  $zoomOutStart: .7;
  $zoomOutEnd: .46;
  @keyframes zoomIn8 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    100% {
      opacity: 1;
    }
  }
  .wrapper-full-page .zoomIn {
    animation-name: zoomIn8;
  }
  @keyframes zoomOut8 {
    from {
      opacity: 1;
      transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
    }
    to {
      opacity: 0;
      transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);

    }
  }
  .wrapper-full-page .zoomOut {
    animation-name: zoomOut8;
  }
  .md-form-group {
    margin: 40px 0 0;
  }
  .pull-right {
    margin: 30 0 -20 0;
  }
</style>